import dayjs from 'tmr/services/dayjs'

/**
 * Modifies mdDateLocale from angular-material
 *
 * @type {ngDecorator}
 */
function mdDateLocaleDecorator($delegate, $filter, $locale) {
  'ngInject'

  /**
   * This is identical to defaultFormatDate in angular-material/components/datepicker/js/dateLocaleProvider.js
   * except that the date format is `shortDate` instead of `M/d/yyyy`, enabling the date to be rendered
   * in the current locale.
   */
  $delegate.formatDate = function tmrFormatDate(date, timezone) {
    if (!date) return ''

    // All of the dates created through ng-material *should* be set to midnight.
    // If we encounter a date where the localeTime shows at 11pm instead of midnight,
    // we have run into an issue with DST where we need to increment the hour by one:
    // var d = new Date(1992, 9, 8, 0, 0, 0);
    // d.toLocaleString(); // == "10/7/1992, 11:00:00 PM"
    var localeTime = date.toLocaleTimeString()
    var formatDate = date
    if (
      date.getHours() === 0 &&
      (localeTime.indexOf('11:') !== -1 || localeTime.indexOf('23:') !== -1)
    ) {
      formatDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        1,
        0,
        0
      )
    }

    return $filter('date')(formatDate, 'shortDate', timezone)
  }

  /**
   * Uses day.js to parse the string in shortDate format back to date
   */
  $delegate.parseDate = function (dateString) {
    return dayjs(
      dateString,
      // dayjs only supports uppercase day (D), month (M) and year (Y)
      $locale.DATETIME_FORMATS.shortDate
        .replace(/d/g, 'D')
        .replace(/m/g, 'M')
        .replace(/y/g, 'Y')
    ).toDate()
  }

  return $delegate
}

export let decorator = ['$mdDateLocale', mdDateLocaleDecorator]
